module.exports = __webpack_public_path__ + "static/img/head9.7c58350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head9.png
// module id = YAdM
// module chunks = 1